import api from './api';

export type SiteContentDocument = Record<string, unknown>;

export const siteContentService = {
  get: async (): Promise<SiteContentDocument> => {
    const response = await api.get<{ success: boolean; data: SiteContentDocument }>('/site-content');
    return response.data.data || {};
  },
  update: async (content: SiteContentDocument): Promise<SiteContentDocument> => {
    const response = await api.put<{ success: boolean; data: SiteContentDocument }>('/site-content', content);
    return response.data.data;
  },
};
